import { render, staticRenderFns } from "./pictureOne.vue?vue&type=template&id=022dac49&scoped=true"
import script from "./pictureOne.vue?vue&type=script&lang=js"
export * from "./pictureOne.vue?vue&type=script&lang=js"
import style0 from "./pictureOne.vue?vue&type=style&index=0&id=022dac49&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022dac49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('022dac49')) {
      api.createRecord('022dac49', component.options)
    } else {
      api.reload('022dac49', component.options)
    }
    module.hot.accept("./pictureOne.vue?vue&type=template&id=022dac49&scoped=true", function () {
      api.rerender('022dac49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentPic/pictureOne/pictureOne.vue"
export default component.exports